/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const sacranatura: CommunityData = {
  code: "sacranatura",
  name: "Sacra Natura",
  inviteCode: "sacra",
  thumbnail: "/assets/customizations/sacraNatura/sacra-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sac-163`,
  socials: {
    instagramLink: "https://www.instagram.com/sacranatura/",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#000000",
      alternativeLogo: {
        src: "/assets/customizations/sacraNatura/logo-white.png",
        styles: "w-[110px] object-contain",
      },
      logo: {
        src: "/assets/customizations/sacraNatura/logo.png",
        styles: "w-[130px] h-[130px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideStyles: "",
      asideBg: "#EF040D",
      contentBg: "#ffffff",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/sacraNatura/sacra-bg.png",
      bgMobile: "/assets/customizations/sacraNatura/sacra-bg.png",
      nonMemberBg: "/assets/customizations/sacraNatura/sacra-auth-bg.png",
      mainFont: "font-['Khand']",
      primaryButton:
        "w-full sm:w-fit !h-[52px] bg-white border-[8px] border-black !px-4 !text-[20px] !leading-[1] font-['Pixeloid'] font-bold !text-black whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-white border-t",
      item: "font-['Pixeloid'] font-bold text-[18px] leading-[18px] h-[40px] flex sm:justify-start justify-center items-center uppercase text-white !pt-1",
      itemSelected: "bg-[#CE0008] text-[#FFFFFF]",
    },
    communityLanding: {
      emptyOrLoadingState: "text-[18px] ml-4 sm:ml-8",
      titles: "font-['Pixeloid'] uppercase text-black text-[24px] leading-6",
      shop: {
        title: "font-['Pixeloid'] font-bold uppercase text-black text-[20px] leading-[20px]",
        text: "text-[18px] leading-[22px] text-black",
        customShopImage: "/assets/customizations/sacraNatura/img_shop.png",
      },
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#000000] bg-black !-mt-6",
        sectionTitle:
          "font-['Pixeloid'] uppercase text-white text-[24px] leading-6 pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "font-['Pixeloid'] font-bold text-white text-[20px] uppercase text-left leading-[1]",
          subtitle:
            "text-[14px] font-['Khand'] font-semibold text-white text-left leading-[1] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#000000] bg-white",
        sectionTitle:
          "font-['Pixeloid'] uppercase text-black text-[24px] leading-6 pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[160px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] h-[183px] sm:!h-[128px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "font-['Pixeloid'] font-semibold text-black text-[18px] uppercase text-left one-line-truncate leading-[22px] mb-2",
          subtitle: "text-[18px] font-['Khand'] text-black text-left leading-[22px]",
          location: "text-[14px] font-['Khand'] text-black text-left leading-[22px]",
          date: "text-[14px] font-['Khand'] text-black text-left leading-[22px]",
        },
      },
    },
    announcement: {
      likeCount: "text-[15px]",
      commentCount: "text-[15px]",
      emptyOrLoadingState: "!text-2xl",
      created: "text-[18px] leading-[22px]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "text-[28px] uppercase font-semibold font-['Pixeloid']",
      description: "text-[18px] leading-[22px]",
      commentIconColor: "",
      likeIconColor: "",
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#000000]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title:
          "font-['Pixeloid'] font-semibold text-black text-[28px] uppercase text-left leading-[28px]",
        subtitle:
          "text-[18px] font-['Khand'] font-semibold text-black text-left leading-[22px] mb-4 mt-2",
        button:
          "w-full sm:w-fit !h-[52px] bg-white border-[8px] border-black !px-4 !text-[20px] !leading-[1] font-['Pixeloid'] font-bold !text-black whitespace-nowrap uppercase mb-4 sm:mb-0",
        questions: "text-[18px] font-['Khand'] text-left leading-[22px] text-black",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header:
          "font-['Pixeloid'] font-semibold uppercase text-black text-[28px] leading-9 text-left",
        text: "text-[18px] font-['Khand'] text-black text-left leading-[22px] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header:
          "font-['Pixeloid'] font-semibold uppercase text-black text-[28px] leading-9 text-left",
        text: "text-[18px] font-['Khand'] text-black text-left leading-[22px] mb-4 max-w-[652px] w-full",
        map: "sm:max-w-[50%] h-[206px] overflow-hidden border border-[#000000]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "font-['Pixeloid'] font-semibold uppercase text-black text-[28px] leading-9 text-left",
        text: "text-[18px] font-['Khand'] text-black text-left leading-[22px]",
      },
      tickets: {
        header:
          "font-['Pixeloid'] font-semibold uppercase text-black text-[28px] leading-9 text-left px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#FFFFFF] border-[8px] border-[#000000] px-4 py-3 text-[#000000] font-['Pixeloid'] font-bold text-[14px] text-left !w-fit uppercase",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto bg-[#ffffff00] mb-4 overflow-hidden",
          media: "!w-[64px] !h-[64px] mr-2 sm:mr-4 border border-[#000000]",
          name: "sm:text-[20px] text-[18px] font-['Pixeloid'] font-semibold uppercase text-black text-left leading-[110%]",
          description:
            "sm:text-[16px] text-[14px] font-['Khand'] text-black text-left leading-[130%] !mt-1 normal-case line-clamp-2 flex flex-row gap-1",
          price:
            "sm:text-[20px] text-[18px] font-['Pixeloid'] text-black text-left leading-[110%] !mt-1",
          quantity: "text-black font-['Khand'] text-[14px] text-left text-nowrap",
          status: "text-[24px] font-['Pixeloid'] uppercase text-black text-left leading-[110%]",
          counterContainer:
            "bg-[#FFF] border-[1px] border-[#000000] !px-4 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#FFFFFF] border-[8px] border-[#000000] px-4 py-3 text-[#000000] font-['Pixeloid'] font-bold text-[14px] text-left !w-fit uppercase",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default sacranatura
